import { ActionReducer, MetaReducer } from '@ngrx/store';
import { environment } from '@env/environment';

export function actionName(
  storeName: string,
  actionDescription: string,
): string {
  return `[${storeName}] ${actionDescription}`;
}

export function debugStore(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    const newState = reducer(state, action);
    const actionPayload = { ...action };
    delete actionPayload.type;
    console.log(`action ${action.type}`, {
      newState,
      payload: actionPayload,
      oldState: state,
    });
    return newState;
  };
}

export const metaReducers: MetaReducer<any>[] = [];

if (!environment.production) {
  metaReducers.unshift(debugStore);
}
